import validationRules from '../../utilities/validationRules';
import forgotPasswordResources from './forgotPasswordResources';

export const emailRequired = validationRules.required(
    forgotPasswordResources.labelUsername
);

